export default __webpack_public_path__ + "static/jcbaey-9c621e49337ea0944cbb21d1a822ca71.jpg";